// Module
var code = "top: 0;\r\nright: 0;\r\nbottom: 0;\r\nleft: 0;\r\nmargin: auto;";
// Exports
export default code;